var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm-add-customer"},[_c('div',{staticClass:"sm-add-customer-inner"},[(!_vm.isMobile)?_c('breadcrumbs-block',{attrs:{"crumbs":_vm.breadcrumbs}}):_vm._e(),_c('form-customer',{attrs:{"backErrors":_vm.formErrors},on:{"submit":_vm.handleCreateCustomer}})],1),_c('sm-spinner',{attrs:{"show":_vm.showSpinner}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }